import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import Contact from "./pages/Contact";
import FltrLiteProInfo from "./pages/FltrLiteProInfo";
import SubscriptionSuccess from "./pages/SubscriptionSuccess";
import ForIndividuals from "./pages/ForIndividuals";
import ForBusiness from "./pages/ForBusiness";
import FltrMax from "./pages/FltrMax";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/fltrlite-pro-info" element={<FltrLiteProInfo />} />
          <Route path="/subscription-success" element={<SubscriptionSuccess />} />
          <Route path="/4individuals" element={<ForIndividuals />} />
          <Route path="/4business" element={<ForBusiness />} />
          <Route path="/fltrmax" element={<FltrMax />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
